import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { handleApiError } from "../../utils/responseHandler";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
  data: any[];
}

export const withdrawQuote = createAsyncThunk(
  "quote/withdraw",
  async (post_data: any, { rejectWithValue }) => {
    const withdrawQuoteURL = `${URL_API}/supplier-portal/quote-request-forms/${post_data.quoteRequestFormID}/quotes/${post_data.quoteID}/withdraw`;

    try {
      const { data } = await axios.put<ResetResult>(
        withdrawQuoteURL,
        post_data.request,
        {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
        },
      );

      return data;
    } catch (error) {
      // @ts-ignore
      if (error?.response?.status === 401) {
        logoutAndRedirect("/sign-in");
      }

      // Use handleApiError to properly structure error responses
      const errorResponse = handleApiError(error);
      return rejectWithValue(errorResponse);
    }
  },
);
